import React from "react"
import Movie from "../Movie/Movie"
import './MovieList.css'
function MovieList({movies=[], onMovieSelect}) {
    if(!movies.length) {
        return <div>no movies</div>
    }
    return <div className="movie-list">{movies.map(mov => <Movie key={mov.id} movie={mov} onMovieSelect={onMovieSelect} />)}</div>
}
export default MovieList;